


















import Vue from "vue"
import SectionTitle from "~/components/guideline/util/SectionTitleWithIcon.vue"
import { priceFormat } from "~/plugins/priceFormatter"
import { convertPaysTypeToLabel } from "~/backendApis/viewModel/projectSearch"
import { ProjectPaysType } from "~/backendApis/viewModel/project"

export default Vue.extend({
  components: {
    SectionTitle,
  },
  props: {
    recruitmentSmallJobCategoryName: {
      type: String,
      default: null,
    },
    prefectureName: {
      type: String,
      default: null,
    },
    recruitmentWorkingFormName: {
      type: String,
      default: null,
    },
    minimumPossibleOperatingHours: {
      type: Number,
      default: null,
    },
    maximumPossibleOperatingHours: {
      type: Number,
      default: null,
    },
    formPath: {
      type: String,
      default: null,
    },
    projectPaysType: {
      type: String,
      default: null,
    },
    projectPaysMin: {
      type: Number,
      default: null,
    },
    projectPaysMax: {
      type: Number,
      default: null,
    },
  },
  computed: {
    possibleOperatingHoursSpan(): string {
      if (
        this.minimumPossibleOperatingHours === null ||
        this.maximumPossibleOperatingHours === null
      ) {
        return ""
      }
      return this.minimumPossibleOperatingHours ===
        this.maximumPossibleOperatingHours
        ? `週${this.minimumPossibleOperatingHours}時間`
        : `週${this.minimumPossibleOperatingHours}~${this.maximumPossibleOperatingHours}時間`
    },
    projectPaysRange(): string {
      return this.projectPaysMin
        ? `${convertPaysTypeToLabel(
            this.projectPaysType as ProjectPaysType
          )} ${priceFormat(this.projectPaysMin)}~${priceFormat(
            this.projectPaysMax
          )}円`
        : convertPaysTypeToLabel(this.projectPaysType as ProjectPaysType)
    },
    rows(): { label: string; content: string }[] {
      return [
        {
          label: "募集職種",
          content: this.recruitmentSmallJobCategoryName,
        },
        {
          label: "稼働時間",
          content: this.possibleOperatingHoursSpan,
        },
        {
          label: "リモートワーク",
          content: this.recruitmentWorkingFormName,
        },
        {
          label: "稼働地域",
          content: this.prefectureName,
        },
        {
          label: "報酬",
          content: this.projectPaysRange,
        },
      ]
    },
  },
  methods: {
    goToEditForm() {
      this.$nuxt.$router.push({ path: this.formPath })
    },
  },
})
